// @flow

import gql from 'graphql-tag';

export default gql`
  query appIntegrationDetailsQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      currentImplementation {
        id
        actions {
          reads {
            helpTextHtmlAst
            hide
            key
            important
            label
          }
          writes {
            helpTextHtmlAst
            hide
            key
            important
            label
          }
          searches {
            helpTextHtmlAst
            hide
            key
            important
            label
          }
        }
      }
      image
      integrationOverviewHtmlAst
      launchDate
      name
    }
  }
`;
